import { useTranslation } from 'react-i18next';
import { SupportTicket } from '@haccp/api-client';
import {
  getSupportStatusClass,
  getSupportStatusText,
  getSupportCategoryClass,
  getSupportCategoryText,
  formatSupportDateTime,
} from '../utils/support';

interface SupportTicketListProps {
  tickets: SupportTicket[];
  isLoading?: boolean;
}

export default function SupportTicketList({ tickets, isLoading = false }: SupportTicketListProps) {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-neutral-600">{t('adminList.loadingTickets')}</div>
      </div>
    );
  }

  if (tickets.length === 0) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-center">
          <div className="text-lg font-medium text-neutral-900">{t('adminList.noTickets')}</div>
          <p className="text-neutral-600 mt-1">{t('adminList.noTicketDesc')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-neutral-200">
            <th className="text-left px-4 py-3 font-medium text-neutral-700">{t('adminList.colCategory')}</th>
            <th className="text-left px-4 py-3 font-medium text-neutral-700">{t('adminList.colStatus')}</th>
            <th className="text-left px-4 py-3 font-medium text-neutral-700">{t('adminList.colCreated')}</th>
          </tr>
        </thead>
        <tbody>
          {tickets.map((ticket) => (
            <tr key={ticket.id} className="border-b border-neutral-100 hover:bg-neutral-50">
              <td className="px-4 py-3">
                <span
                  className={`inline-block px-2.5 py-1 rounded-full text-xs font-medium ${getSupportCategoryClass(
                    ticket.category
                  )}`}
                >
                  {getSupportCategoryText(ticket.category)}
                </span>
              </td>
              <td className="px-4 py-3">
                <span
                  className={`inline-block px-2.5 py-1 rounded-full text-xs font-medium ${getSupportStatusClass(
                    ticket.status
                  )}`}
                >
                  {getSupportStatusText(ticket.status)}
                </span>
              </td>
              <td className="px-4 py-3 text-neutral-700">
                {formatSupportDateTime(ticket.createdAt)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
